import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
export var imageUrlToBlob = function imageUrlToBlob(_ref) {
  var url = _ref.url,
      timeout = _ref.timeout;
  return new _Promise(function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(resolve, reject) {
      var timeoutId, response, blobData, reader;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              timeoutId = setTimeout(function () {
                reject("Request to ".concat(url, " has timed out!"));
              }, timeout);
              _context.next = 3;
              return fetch(url);

            case 3:
              response = _context.sent;

              if (!(!response.ok || response.status >= 400)) {
                _context.next = 8;
                break;
              }

              clearTimeout(timeoutId);
              reject('Remote content cannot be reached!');
              return _context.abrupt("return");

            case 8:
              _context.next = 10;
              return response.blob();

            case 10:
              blobData = _context.sent;

              if (blobData instanceof Blob) {
                _context.next = 15;
                break;
              }

              clearTimeout(timeoutId);
              reject('Returned data is not a blob!');
              return _context.abrupt("return");

            case 15:
              reader = new FileReader();
              reader.readAsDataURL(blobData);

              reader.onerror = function () {
                clearTimeout(timeoutId);
                reject(reader.error);
                reader.abort();
              };

              reader.addEventListener('load', function readerLoaded() {
                clearTimeout(timeoutId);

                if (this.result) {
                  resolve(this.result);
                } else {
                  reject('Could not read blob data from response!');
                }

                reader.removeEventListener('load', readerLoaded, false);
              }, false);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }());
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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